'use client';

import { useState } from 'react';
import type { FacilityData, FacilitySection } from '@/app/_lib/parseFacilities';
import { EnhancedMapWrapper } from './EnhancedMapWrapper';
import { FacilityLegend } from './FacilityLegend';
import { InteractiveLocations } from './InteractiveLocations';

interface LocationsClientProps {
  initialFacilitySections: FacilitySection[];
  corporateOffice: {
    title: string;
    phone: string;
    address: {
      street: string;
      city: string;
      state: string;
      zipcode: string;
    };
  };
}

export function LocationsClient({ initialFacilitySections }: LocationsClientProps) {
  const [selectedFacility, setSelectedFacility] = useState<FacilityData | null>(null);

  // Use the geocoded data passed from server
  const facilitySections = initialFacilitySections;
  const allFacilities = initialFacilitySections.flatMap((section) => section.facilities);

  const handleFacilityClick = (facility: FacilityData) => {
    setSelectedFacility(facility);
  };

  return (
    <>
      {/* Map */}
      <div className='mb-12' id='map-container'>
        <EnhancedMapWrapper facilities={allFacilities} selectedFacility={selectedFacility} />
      </div>

      {/* Legend */}
      <FacilityLegend />

      {/* Interactive Facilities Grid */}
      <InteractiveLocations facilitySections={facilitySections} onFacilityClick={handleFacilityClick} />
    </>
  );
}

export default LocationsClient;
